import {BaseIdCodeQuery, BaseIdQuery} from 'common-shared';

export class CostPriceComponentQuery extends BaseIdCodeQuery {
  Description: string;
  TypeClv: string;

  get DisplayName(): string {
    return BaseIdQuery.getDisplayName([this.Code, this.Description]);
  }

  static Columns() {
    return [...BaseIdCodeQuery.Columns(), 'Description', 'TypeClv'];
  }
}
